export default __webpack_public_path__ + "static/media/1898.e1011b48.png";